import * as React from 'react';
import { Typography, Box } from '@mui/material';
import { Progress } from '@manulife/mux';

export const TextLink = ({
  sx,
  preText,
  linkText,
  postText,
  href,
  onClick,
  loading = false,
}) => {
  return (
    <Box sx={{ ...sx, ...styles.container }}>
      <Typography sx={styles.link}>
        {preText}
        <a href={href} onClick={onClick}>
          {linkText}
        </a>
        {postText}
      </Typography>
      <Progress doShow={loading} isFloating={false} size={18} magnitude={5} />
    </Box>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '5px',
  },
  link: {
    '& a': {
      fontWeight: '600',
      textDecoration: 'underline',
      textDecorationColor: '#0000C1',
      textDecorationThickness: '1px',
      textDecorationSkipInk: 'none',
      textUnderlineOffset: '6px',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
};
